import {PlayerReduxState} from "../types";

export default function getCurrentActionAttempts(state: PlayerReduxState): number {
  return state.currentActionAttempts;
}